<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="客户" prop="shipmentCode">
        <shipmentSelect ref="shipmentSelect" style="width: 100%" @setCustomerCode="setCustomerCode" />
      </el-form-item>
      <el-form-item label="备注" prop="remarks" style="margin-right:15px">
        <el-input v-model="form.remarks" placeholder="请输入备注" />
      </el-form-item>
      <el-form-item label="合同名称" prop="name" style="margin-right:15px">
        <el-input v-model="form.name" placeholder="请输入合同名称" />
      </el-form-item>
      <el-form-item label="附件地址" prop="contractPath">
        <el-upload
          ref="upload"
          :headers="headers"
          class="upload-demo"
          :action="uploadUrl"
          :auto-upload="true"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeUploadFile"
          :file-list="fileList"
        >
          <el-button slot="trigger" size="small" type="primary">
            选取文件
          </el-button>
        </el-upload>
        <el-input v-model="form.fileName" type="hidden" />
        <el-input v-model="form.contractPath" type="hidden" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import { getToken } from '@/utils/auth';
export default {
  name: "ContractEdit",
  data() {
    return {
      uploadUrl: this.BASE_API_URL + "ntocc-tps-api/fileUpload",
      headers: {
        Authorization: "Bearer " + getToken(),
        deviceId: "0000000000",
      },
      emptyForm: {},
      partys: {},
      form: {
        code: "",
        shipmentCode: "",
        name: "",
        contractPath: "",
      },
      fileList: [],
      rules: {
        code: [
          { required: true, message: "请输入预约入库单号", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        shipmentCode: [
          { required: true, message: "请输入客户", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "请输入合同名称", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        contractPath: [
          { required: true, message: "请输入附件地址", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      this.fileList = [];
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      request({ url: `/ntocc-wms-api/contract/${code}`, method: "get" }).then(
        (response) => {
          this.form.code = response.data.fileInfo.code;
          this.form.name = response.data.fileInfo.name;
          this.form.contractPath = response.data.entity.contractPath;
          this.form.shipmentCode = this.formattershipment(
            response.data.entity.shipmentCode
          );
          this.fileList.push(response.data.fileInfo);
        }
      );
    },
    setCustomerCode(value) {
      this.form.shipmentCode = value.code;
      this.form.shipmentName = value.name;
    },
    // 翻译客户类型
    formattershipment(cellValue) {
      const sd = this.partys.find((i) => i.code === cellValue);
      return sd.name;
    },
    
    //上传前校验
    beforeUploadFile(file) {
      let size = file.size / 1024 / 1024
      if(size > 10) {
        this.$message.error('上传文件大小不能超过 10MB!')
        return false
      }
      // 获取token值，实时获取
      this.headers.Authorization = 'Bearer ' + getToken()
      return true
    },
    handleAvatarSuccess(response, file, fileList) {
      if(response.status==500){
        this.$message.error(response.msg)
      } else {
        this.$message({ message: response.msg, type: "success" });
        this.form.contractPath = response.data;
        this.form.fileName = file.name;
      }
    },

    // 提交
    funcSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({ url: "/ntocc-wms-api/contract", method: "put", data }).then(
            (response) => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherEditMethod");
            }
          );
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
